import { createContext } from 'react';

export const PlatformContext = createContext(null);
